import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./lib/auth";
import PublicLayout from "./components/site/PublicLayout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Pricing from "./pages/Pricing";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/fr" replace />} />
            <Route path="/services" element={<Navigate to="/fr/services" replace />} />
            <Route path="/galerie" element={<Navigate to="/fr/galerie" replace />} />
            <Route path="/a-propos" element={<Navigate to="/fr/a-propos" replace />} />
            <Route path="/contact" element={<Navigate to="/fr/contact" replace />} />
            <Route path="/blog" element={<Navigate to="/fr/blog" replace />} />
            <Route path="/tarifs" element={<Navigate to="/fr/tarifs" replace />} />
            <Route path="/pricing" element={<Navigate to="/en/pricing" replace />} />

            <Route path="/:lang" element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="services" element={<Services />} />
              <Route path="a-propos" element={<About />} />
              <Route path="about" element={<About />} />
              <Route path="galerie" element={<Gallery />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="contact" element={<Contact />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog/:slug" element={<BlogPost />} />
              <Route path="tarifs" element={<Pricing />} />
              <Route path="pricing" element={<Pricing />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
